import { Button } from "@/components/ui/button";
import { Loader2, ArrowUp } from "lucide-react";

interface LoadMoreButtonProps {
  remaining: number;
  isLoadingMore: boolean;
  isAllLoaded: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
}

export function LoadMoreButton({ 
  remaining, 
  isLoadingMore, 
  isAllLoaded, 
  hasMore, 
  onLoadMore 
}: LoadMoreButtonProps) {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (isAllLoaded && remaining <= 0) {
    return (
      <div className="text-center py-8 space-y-4">
        <p className="text-muted-foreground font-light" aria-live="polite">
          All items loaded
        </p>
        <Button
          onClick={scrollToTop}
          variant="outline"
          size="lg"
          className="min-w-[140px] bg-background text-foreground hover:bg-muted border-border"
        >
          <ArrowUp className="mr-2 h-4 w-4" />
          Back to Top
        </Button>
      </div>
    );
  }

  if (!hasMore) {
    return null;
  }

  return (
    <div className="text-center py-8 space-y-4">
      <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
        <Button
          onClick={onLoadMore}
          disabled={isLoadingMore}
          variant="default"
          size="lg"
          className="min-w-[140px] bg-primary text-primary-foreground hover:bg-primary/90"
          aria-live="polite"
        >
          {isLoadingMore ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Loading...
            </>
          ) : (
            "Load More"
          )}
        </Button>
        
        <Button
          onClick={scrollToTop}
          variant="outline"
          size="lg"
          className="min-w-[140px] bg-background text-foreground hover:bg-muted border-border"
        >
          <ArrowUp className="mr-2 h-4 w-4" />
          Back to Top
        </Button>
      </div>
      
      {remaining > 0 && (
        <p className="text-sm text-muted-foreground font-light" aria-live="polite">
          {remaining} remaining
        </p>
      )}
    </div>
  );
}